// GraphQl
import { useGetUserNotificationsCountQuery } from '@sketch/gql-types'

import { WatchQueryFetchPolicy } from '@apollo/client'

import { ErrorHandler } from '@sketch/tracing'

interface UseGetUnreadNotificationsCountProps {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useGetUnreadNotificationsCount = (
  props: UseGetUnreadNotificationsCountProps = {}
): number => {
  const { fetchPolicy = 'cache-first' } = props
  const { data } = useGetUserNotificationsCountQuery({
    fetchPolicy,
    onError: error => {
      ErrorHandler.shouldNeverHappen(
        `Unexpected error fetching me.notifications.meta: '${error.message}'`
      )
    },
  })

  return data?.me.unreadNotificationsCount?.meta.totalCount ?? 0
}
